import { render, staticRenderFns } from "./ProjectAdvertBanner.vue?vue&type=template&id=70da3358"
import script from "./ProjectAdvertBanner.vue?vue&type=script&lang=js"
export * from "./ProjectAdvertBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports